import { useCallback } from 'react'
import {
  FileObject,
  getFileFromFileObjects,
  useMutationUploadImages
} from '@plandi/common'

import { PortfolioProjectImage } from './portfolio.types'

export const useUploadImageProjectPortfolio = () => {
  const mutationUploadImages = useMutationUploadImages()

  return useCallback(
    async (images?: PortfolioProjectImage[]) => {
      if (!images?.length) {
        throw new Error('Должно присутствовать хотя бы одно изображение')
      }

      const filterImages = images.filter(
        (
          image
        ): image is { url: FileObject; id: number; description?: string } =>
          Boolean(image.url)
      )

      const fileObjs = filterImages.map((image) => image.url)

      const files = getFileFromFileObjects(fileObjs)

      const newImages = await mutationUploadImages.mutateAsync({
        files
      })

      return filterImages.map((image) =>
        'file' in image.url
          ? {
              id: newImages?.shift()?.id as number,
              description: image.description
            }
          : { id: image.id, description: image.description }
      )
    },
    [mutationUploadImages]
  )
}
